import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { CmsStudioService } from '../../cms/cms-studio.service';
import { IBreadcrumb } from '../../breadcrumb/breadcrumb.interface';

@Component({
  selector: 'app-cms-wrapper',
  templateUrl: './cmswrapper.component.html',
  styleUrls: ['./cmswrapper.component.css']
})
export class CmsWrapperComponent implements OnInit {
  title = '';
  public breadcrumbs: IBreadcrumb[] = [];

  constructor(private router: Router, private ngProgress: NgProgress, private activeRouter: ActivatedRoute, 
    private cmsStudioService: CmsStudioService) { 
      this.activeRouter.params.subscribe(params => {
        var page = params["page"];
        if(page && page.length > 0){
          if(page == 'faq') {
            this.breadcrumbs.push(              
              {label: "FAQ", url: "/doc/faq"}
            )
            console.log(this.breadcrumbs);
          }
          if(page == 'apidocumentation') {
            this.breadcrumbs.push(              
              {label: "API Document", url: "/doc/apidocumentation"}
            )
            console.log(this.breadcrumbs);
          }
        }
      })
    }

  ngOnInit() {
   
  }
}
